// Entry point for the build script in your package.json
import { App } from './app'
import { Figures } from './figures'
import ValueParser from './utils/value_parser'
import PercentService from './utils/percent_service'
import { PeriodBuilder } from './periods/period_strategy'

window.app = new App()
window.Figures = Figures
window.ValueParser = ValueParser
window.PercentService = PercentService
window.PeriodBuilder = PeriodBuilder


// Utility
// import * as strftime from 'strftime'
// import 'moment'

// Rails
import "@hotwired/turbo-rails"
import "./controllers"

// Lexxy
import "@37signals/lexxy"
import "./lexxy_extensions/sanitation_override"
import "./lexxy_extensions/all"

import "@rails/actiontext"

import "./turbo_stream_actions"
window.Turbo = Turbo

// UI
import "@github/relative-time-element"

// This is ugly, but the sorting library we use doesn't provide a
// way to import these sorting functions in a conventional way
// See: https://github.com/tristen/tablesort/issues/94

import * as Tablesort from 'tablesort'
window.Tablesort = Tablesort;
require('tablesort/src/sorts/tablesort.date.js')
require('tablesort/src/sorts/tablesort.number.js')

const beforePrint = function() {
  window.app.tabs.forEach((tab) => { tab.fetchContent() })
  window.app.charts.forEach((chart) => { chart.resize() })
}

const afterPrint = () => {
  window.app.charts.forEach((chart) => { chart.resize() })
}

window.onbeforeprint = beforePrint;
window.onafterprint = afterPrint;
